<template>
<div class="chapter">
<div class="inner_page">
<article epub:type="frontmatter">
<div class="bodymatter" epub:type="bodymatter">
<section epub:type="division" id="fm2">
<div class="dis_img" id="img6_1"><img alt="" src="Images/vi-1.jpg"/>
<p class="caption">Aretha Franklin, c. 1965.</p>
</div>
</section>
</div>
</article>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781454934721_fm2.vue?7b541d7f